const dataStart = profile => {
  this.startDate = profile.professional.specialization.start
  return this.startDate
}

export default {
  dataStart
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/resources/methods.js